import React from 'react';
import { IAssistBodyProps } from './assistBody.types';
import HearAndConfirmBody from './HearAndConfirmBody';

export type { IAssistBodyProps };

/**
 * The per-type body slot of the assist card. Each type ticket registers its
 * body here (hear_and_confirm: HITL-1783). Only registered types reach a card:
 * `RENDERABLE_ASSIST_TYPES` drops the rest at receipt, so there is no generic
 * fallback (review B1.9); a type is added there once its body is ready.
 */
export const assistRequestBodies: Partial<
  Record<string, React.ComponentType<IAssistBodyProps>>
> = {
  hear_and_confirm: HearAndConfirmBody,
};

/** The type's body, or undefined for a type with none (never shown). */
export const getAssistBody = (type: string) => assistRequestBodies[type];
